// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"533":"43aa1b78","943":"a6c1c36c"}[chunkId] + ".chunk.css";
};